import { TrialField, TrialLayout } from '@/types/trials'

export const emailPattern =
	/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const phoneNumberPattern =
	/^\+?([0-9]{1,3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4,6})$/
export const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[/\W/])(?=.{12,})/
// Not allow urls and emails in first and last name
const textPattern = /^[^<>()[\]\\.,;:\s@\"]+$/

const fields: TrialField[] = [
	{
		id: '21941',
		fieldName: 'first_name',
		fieldType: 'text',
		required: true,
		pattern: textPattern
	},
	{
		id: '21942',
		fieldName: 'last_name',
		fieldType: 'text',
		required: true,
		pattern: textPattern
	},
	{
		id: '21943',
		fieldName: 'phone_number',
		fieldType: 'text',
		required: true,
		pattern: phoneNumberPattern
	},
	{
		id: '21944',
		fieldName: 'email',
		fieldType: 'email',
		required: true,
		pattern: emailPattern
	},
	{
		id: '21945',
		fieldName: 'password',
		fieldType: 'password',
		required: true,
		pattern: passwordPattern
	},
	{
		id: '21946',
		fieldName: 'name',
		fieldType: 'text',
		required: true,
		maxLength: 40
	},
	{
		id: '21947',
		fieldName: 'projectedAnnualRevenue',
		fieldType: 'select',
		options: [
			{ id: '84551', value: 'No Revenue' },
			{ id: '29888', value: '<$50k' },
			{ id: '50437', value: '$50k to $250k' },
			{ id: '85303', value: '$250k to $1M' },
			{ id: '34300', value: '$1M to $20M' },
			{ id: '27131', value: '$20M to $50M' },
			{ id: '69328', value: '$50M to $100M' },
			{ id: '49392', value: '$100M+' },
			{ id: '51596', value: "I'm not sure" }
		],
		required: true
	},
	{
		id: '21948',
		fieldName: 'region',
		fieldType: 'select',
		defaultValue: 'NA',
		options: [
			{ id: '14001', value: 'NA' },
			{ id: '14002', value: 'EU' },
			{ id: '14003', value: 'APAC' }
		],
		required: true,
		hintText: true
	}
]

export const trialLayout: TrialLayout = {
	id: '21940',
	additionalFields: [
		{
			id: '21951',
			fieldName: 'currentWebsite',
			fieldType: 'select',
			options: [
				{ id: '55311', value: 'yes' },
				{ id: '55312', value: 'no' }
			]
		},
		{
			id: '21952',
			fieldName: 'industry',
			fieldType: 'select',
			options: [
				{ id: '11922', value: 'Animals & Pet Supplies' },
				{ id: '89508', value: 'Fashion & Apparel' },
				{ id: '27397', value: 'Arts, Entertainment & Media' },
				{ id: '32681', value: 'Baby & Toddler' },
				{ id: '11427', value: 'Business & Industrial' },
				{ id: '57480', value: 'CBD' },
				{ id: '36202', value: 'Digital Goods & Software' },
				{ id: '27977', value: 'Education' },
				{ id: '28296', value: 'Electronics' },
				{ id: '29638', value: 'Food & Beverage' },
				{ id: '94248', value: 'Hardware & Tools' },
				{ id: '89453', value: 'Health & Beauty' },
				{ id: '77694', value: 'Home, Garden & Furniture' },
				{ id: '91528', value: 'Luggage & Bags' },
				{ id: '52683', value: 'Novelty' },
				{ id: '99499', value: 'Office Supplies' },
				{ id: '49533', value: 'Religious & Non-Profit' },
				{ id: '30564', value: 'Restaurants & Grocery' },
				{ id: '38860', value: 'Services' },
				{ id: '81956', value: 'Sporting Goods' },
				{ id: '12259', value: 'Toys & Games' },
				{
					id: '79960',
					value: 'Travel, Recreation & Leisure'
				},
				{ id: '64069', value: 'Vehicle & Parts' },
				{ id: '49302', value: 'Other' }
			]
		},
		{
			id: '21953',
			fieldName: 'experience',
			fieldType: 'select',
			options: [
				{
					id: '58469',
					value: 'Add an online store to my offline business'
				},
				{
					id: '83655',
					value: 'Expand my online business'
				},
				{
					id: '38327',
					value: 'Switching from a Competitor'
				},
				{
					id: '39176',
					value: 'Research as a student, app developer or job applicant'
				},
				{
					id: '32454',
					value: 'Set up a store for a client'
				},
				{ id: '95499', value: 'Start an online business' },
				{ id: '68502', value: `I'm a BigCommerce customer` }
			]
		}
	],
	fields
}
